<script setup>
import { ref, computed } from "vue";
import { useStore } from "vuex";

const store = useStore();

const couponCode = computed(() => store.getters["checkout/couponCode"]);
const isOrderLoading = computed(() => store.getters["loading/currentOrder"]);
const isDiscountApplied = computed(() => Boolean(store.getters["checkout/totals"]?.promotionTotal));

const couponModel = ref(couponCode.value);
const error = ref();

const handleSubmit = async () => {
  try {
    error.value = null;
    if (isDiscountApplied.value) {
      await store.dispatch("checkout/applyCouponCode", { coupon: null });
      couponModel.value = null;
    } else {
      await store.dispatch("checkout/applyCouponCode", { coupon: couponModel.value });
    }
  } catch (err) {
    error.value = err.message;
  }
};
</script>

<template>
  <div class="checkout-coupon">
    <form class="checkout-coupon__form" @submit.prevent="handleSubmit">
      <input
        v-model="couponModel"
        placeholder="Coupon Code"
        type="text"
        class="checkout-coupon__field"
        :disabled="isOrderLoading || isDiscountApplied"
      />
      <button type="submit" class="checkout-coupon__action" :disabled="isOrderLoading">
        {{ isDiscountApplied ? "Remove" : "Apply" }}
      </button>
    </form>
    <div class="checkout-coupon__error" v-if="error">{{ error }}</div>
  </div>
</template>

<style scoped lang="scss">
@import "frontend/init/jiffy/mixin";
@import "frontend/init/pod/settings";

.checkout-coupon {
  display: flex;
  flex-direction: column;
  gap: 4px;

  &__form {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  &__error {
    text-align: center;
    font-size: 12px;
    color: $pod-danger;
  }

  &__field {
    padding: 16px;
    flex: 1;
    width: 100%;
    height: 52px;
    border: 2px solid $pod-geyser;
    border-radius: 6px;
    text-align: inherit;
  }

  &__action {
    flex-shrink: 0;
    padding: 0 24px;
    height: 52px;
    border: 0;
    border-radius: 6px;
    font-size: 20px;
    font-weight: 500;
    cursor: pointer;
    background-color: $pod-mirage;
    color: $white;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    &:focus,
    &:hover {
      opacity: 0.7;
    }
  }
}
</style>
